module.exports = __webpack_public_path__ + "static/media/verbs_img.200a95fb.PNG";